import { Component, Inject, OnInit } from '@angular/core';
import { Icons } from 'src/app/shared/cons/icons';
import { IProducto } from '../../../procesos/dialog/models/IProducto';
import { IProductoAnidado } from '../../../procesos/dialog/models/IProductoAnidado';
import { Msjs, Msjs_Validations } from 'src/app/shared/cons/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { UIService } from 'src/app/shared/services/ui.services';
import { SnackBarType } from 'src/app/shared/types/snackbar-type';
import { ICaracteristicaProducto } from '../../models/CaracteristicaProducto';

@Component({
  selector: 'app-listar-cantidad-productos-into',
  templateUrl: './listar-cantidad-productos-into.component.html',
  styleUrls: ['./listar-cantidad-productos-into.component.scss']
})
export class ListarCantidadProductosIntoComponent implements OnInit {
  readonly Icons: typeof Icons = Icons;
  isLoading:boolean=false;
  producto!:IProducto;
  listaSubProductos: IProductoAnidado[]=[];
  subProductoSel:IProductoAnidado[]=[];
  nroProductos:number[]=[];
  caractProdReturn:ICaracteristicaProducto[]=[];

  readonly Msjs_Validations: typeof Msjs_Validations = Msjs_Validations;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datoPasado:any,
    private dialogRef:MatDialogRef<ListarCantidadProductosIntoComponent>,
    private uiService: UIService,
  ) { }

  ngOnInit(): void {
    this.producto =  JSON.parse(JSON.stringify(this.datoPasado.dato))  as IProducto;
    let cont =0
    while (cont < this.producto.cantidad_productos_combo_seleccionables!){
      cont+=1;
      this.nroProductos.push(cont);
    }
    this.listaSubProductos!.length = this.producto.cantidad_productos_combo_seleccionables!;
  }

  onClose() {
    this.dialogRef.close({});
  }
 
  async seleccionarSubProductoCombo(subProd:IProductoAnidado, index:number){      
    this.listaSubProductos!.splice(index,1,subProd);        
  }

   onSubmit(f:NgForm){
    if(f.valid){      
      this.dialogRef.close({listaSubProductos :  this.listaSubProductos});  
    }

  }

  Limpiar(f:NgForm){
    f.reset()
  }



}
